import { render, staticRenderFns } from "./ApplicationDetails.vue?vue&type=template&id=1d317fb2&scoped=true"
import script from "./ApplicationDetails.vue?vue&type=script&lang=js"
export * from "./ApplicationDetails.vue?vue&type=script&lang=js"
import style0 from "./ApplicationDetails.vue?vue&type=style&index=0&id=1d317fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d317fb2",
  null
  
)

export default component.exports